import { render, staticRenderFns } from "./formAddVendor.vue?vue&type=template&id=2acc4ebc&scoped=true"
import script from "./formAddVendor.vue?vue&type=script&lang=js"
export * from "./formAddVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc4ebc",
  null
  
)

export default component.exports